// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-dimensions/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springDimensionsEN: PageEntry = {
  id: "post.federabmessungen",
  locale: "en",
  slug: "spring-dimensions",
  seo: {
    title: "Glossary: Spring dimensions explained simply | Dietz GmbH",
    description: "The spring dimensions refer to the geometric dimensions of a spring that determine its size and shape. These dimensions include parameters such as wire diameter, number of coils, o",
  },
  type: "post",
  h1: "Glossary: Spring dimensions explained simply",
  intro: "The spring dimensions refer to the geometric dimensions of a spring that determine its size and shape. These dimensions include parameters such as wire diameter, number of coils, outer diameter and free length. The precise definition of the spring dimensions is crucial for the functionality and performance of the spring in a particular application. Engineers and designers take into account the physical requirements and loads to ensure optimal dimensions for an efficient spring design.",
  blocks: [

  ],
};
